import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@services/auth.guard';

import { OldPasswordComponent } from '@pages/reset-password/old-password/old-password.component';
import { SettingsScreenComponent } from '@pages/settings-screen/settings-screen.component';
import { passwordChangeGuard } from '@services/passwordChangeGuard';
import { ChangeEmailComponent } from './views/change-email/change-email.component';
import { OldEmailComponent } from './views/old-email/old-email.component';
import {
  SettingsDataResolver,
  ChangeEmailDataResolver,
  OldPasswordDataResolver,
} from './resolvers';
import { NotificationsComponent } from '@pages/notifications/notifications.component';
import { PatientMessageComponent } from '@pages/patient-message/patient-message.component';
import { InformationComponent } from '@pages/information/information.component';
import { notificationsDeactivateGuard } from '@services/notification/notifications-deactivate.guard';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('@pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'message',
    canActivate: [AuthGuard],
    component: PatientMessageComponent,
  },
  {
    path: 'confirm-password',
    component: OldEmailComponent,
    canActivate: [AuthGuard],
    resolve: { data: ChangeEmailDataResolver },
  },
  {
    path: 'change-email',
    component: ChangeEmailComponent,
    canActivate: [AuthGuard, passwordChangeGuard],
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  // Call-center routes use their own guard and isolated session.
  {
    path: 'call-center',
    loadChildren: () =>
      import('@pages/call-center/call-center.routes').then(
        (m) => m.CALL_CENTER_ROUTES,
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('@pages/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule,
      ),
  },
  {
    path: 'old-password',
    component: OldPasswordComponent,
    canActivate: [AuthGuard],
    resolve: { data: OldPasswordDataResolver },
  },
  {
    path: 'settings',
    component: SettingsScreenComponent,
    canActivate: [AuthGuard],
    resolve: { data: SettingsDataResolver },
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [notificationsDeactivateGuard],
  },
  {
    path: 'information',
    component: InformationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unsubscribe',
    loadChildren: () =>
      import('@pages/unsubscribe/unsubscribe.module').then(
        (m) => m.UnsubscribeModule,
      ),
  },
  {
    path: 'payment_failure',
    loadChildren: () =>
      import('@pages/payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: 'payment_success',
    loadChildren: () =>
      import('@pages/payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: '404',
    loadChildren: () =>
      import('@pages/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('@pages/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
